import { Injectable, Inject } from "@angular/core";
import { CanActivate, CanActivateChild, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { Observable } from "rxjs";
import { ContextService } from "@core/service/context.service";
import { SESSION_STORAGE, StorageService } from "ngx-webstorage-service";

@Injectable({
  providedIn: "root"
})
export class HasContextGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(
    protected _contextService: ContextService,
    protected _router: Router,
    @Inject(SESSION_STORAGE) protected _storage: StorageService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._redirectWithOutContext(state);
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._redirectWithOutContext(state);
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return this._hasContext();
  }

  /**
   * If there is context or not currently
   */
  protected _hasContext(): boolean {
    return this._contextService.hasContext$.getValue();
  }

  /**
   * Check for context; if none, redirect to the context selector
   */
  protected _redirectWithOutContext(state: RouterStateSnapshot): boolean | UrlTree {
    if (!this._hasContext()) {
      this._storage.set("redirectUponContext", state.url);
      return this._router.parseUrl("/context");
    }
    return true;
  }
}
